// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface ITestEndpointCommandParams {
	endpointId: string | undefined;

	testInt1: number | undefined;

	testInt2: number | undefined;

	testInt3: number | undefined;

	testString1: string | undefined;

	testString2: string | undefined;

	testString3: string | undefined;

	$type?: string | undefined;
}
export class TestEndpointCommandParams {
	constructor(data?: ITestEndpointCommandParams) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	endpointId: string | undefined;

	testInt1: number | undefined;

	testInt2: number | undefined;

	testInt3: number | undefined;

	testString1: string | undefined;

	testString2: string | undefined;

	testString3: string | undefined;

	static $type: string = "CoreApi.Models.DeviceCommands.TestEndpointCommandParams, ";
	$type?: string | undefined = TestEndpointCommandParams.$type;
}

